<template>
  <div class="intangibleItem-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <DatePicker type="datetimerange"
                      format="yyyy-MM-dd"
                      :value="datePic"
                      @on-change="changeDate"
                      style="width: 200px"
                      placeholder="开始时间 - 结束时间"></DatePicker>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.area1"
                  clearable
                  placeholder="省"
                  @on-change="shengChange">
            <Option v-for="item in shengList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.area2"
                  clearable
                  placeholder="市"
                  @on-change="shiChange">
            <Option v-for="item in shiList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.area3"
                  clearable
                  placeholder="县">
            <Option v-for="item in quList"
                    :value="item.id"
                    :key="item.id">{{item.areaname}}</Option>
          </Select>
        </FormItem>
      </Form>
      </Col>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Select v-model="formItem.cate_id"
                  clearable
                  style="width:150px"
                  placeholder="请选择栏目...">
            <Option v-for="item in cateList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.level_id"
                  clearable
                  style="width:150px"
                  placeholder="请选择等级...">
            <Option v-for="item in levelList"
                    :value="item.id"
                    :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  style="width:80px"
                  placeholder="请选择状态...">
            <Option v-for="item in statusList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入关键词查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable(1)">查找</Button>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="resetFormItem()">重置</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
        <FormItem>
          <Button @click="exportData()"
                  type="default"
                  class="f-l">导出</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1000"
            :mask-closable="false"
            :styles="styles">
      <Form :model="formData"
            :label-width="60"
            ref="intangibleItemValidate"
            :rules="intangibleItemValidate">
        <Row :gutter="32">
          <Col span="8">
          <FormItem label="项目分类"
                    label-position="top">
            <Select v-model="intangibleItem.cate_id"
                    clearable
                    filterable
                    placeholder="项目分类">
              <Option v-for="item in cateList"
                      :value="item.id"
                      :key="item.id">{{item.name}}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="项目类型"
                    label-position="top">
            <Input v-model="name"
                   readonly></Input>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label="级别"
                    label-position="top">
            <Select v-model="intangibleItem.level_id"
                    clearable
                    filterable
                    placeholder="选择级别">
              <Option v-for="item in levelList"
                      :value="item.id"
                      :key="item.id">{{item.title}}</Option>
            </Select>
          </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="8">
          <FormItem label="省-市-县"
                    label-position="top">
            <Select v-model="intangibleItem.area1"
                    placeholder="省"
                    @on-change="shengChange">
              <Option v-for="item in shengList"
                      :value="item.id"
                      :key="item.id">{{item.areaname}}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label=" "
                    label-position="top">
            <Select v-model="intangibleItem.area2"
                    placeholder="市"
                    @on-change="shiChange">
              <Option v-for="item in shiList"
                      :value="item.id"
                      :key="item.id">{{item.areaname}}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="8">
          <FormItem label=" "
                    label-position="top">
            <Select v-model="intangibleItem.area3"
                    placeholder="县">
              <Option v-for="item in quList"
                      :value="item.id"
                      :key="item.id">{{item.areaname}}</Option>
            </Select>
          </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="24">
          <FormItem label="文章标题"
                    label-position="top">
            <Input v-model="intangibleItem.title"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="24">
          <FormItem label="认证名称"
                    label-position="top">
            <Input v-model="intangibleItem.auth_title"></Input>
          </FormItem>
          </Col>
        </Row>
        <Row :gutter="32">
          <Col span="24">
          <FormItem label="关键字"
                    label-position="top">
            <Input v-model="intangibleItem.keywords"></Input>
          </FormItem>
          </Col>
        </Row>
        <FormItem label="描述"
                  label-position="top">
          <Input type="textarea"
                 v-model="intangibleItem.describe"
                 :rows="3"
                 placeholder="请输入描述" />
        </FormItem>
        <FormItem label="封面图"
                  prop="thumb">
          <upload-thumb v-model="intangibleItem.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="230"
                        :autoCropHeight="230"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:230*230,大小不超过2M'"></upload-thumb>
        </FormItem>

        <FormItem label="推荐"
                  label-position="top">
          <RadioGroup v-model="PosStatus">
            <Radio label="否"></Radio>
            <Radio label="是"></Radio>
          </RadioGroup>
        </FormItem>
        <Row :gutter="32">
          <Col span="12">
          <FormItem label="状态"
                    label-position="top">
            <RadioGroup v-model="bigStatus">
              <Radio label="正常"></Radio>
              <Radio label="禁用"></Radio>
            </RadioGroup>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="发布时间"
                    label-position="top">
            <DatePicker type="datetime"
                        placement="top"
                        format="yyyy-MM-dd HH:mm:ss"
                        :value="datePicTwo"
                        @on-change="changeDateTwo"
                        style="width: 200px;z-index: 1000"
                        placeholder="发布时间"></DatePicker>
          </FormItem>
          </Col>
        </Row>
        <FormItem label="相册"
                  prop="thumb">
          <upload-thumb v-model="intangibleItem.attrs"
                        ref="uploadthumbTwo"
                        :defaultList="thumblistTwo"
                        :autoCropWidth="686"
                        :autoCropHeight="284"
                        tip="<span style='color:#ff2121'>图片格式:jpg、jpeg、png、gif,<br>建议图片尺寸:686*284,大小不超过2M</span>"></upload-thumb>
        </FormItem>
        <FormItem label="内容">
          <!--                    <editor-bar v-model="editor.info" :isClear="isClear"  ref="editContent" @change="change"></editor-bar>-->
          <UEditor v-model="editor.info"
                   ref="editContent"></UEditor>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false">取消</Button>
        <Button type="primary"
                @click="createintangibleItem('intangibleItemValidate')">提交</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";
import uploadthumbTwo from "../common/thumb";
import UEditor from "../common/ueditor";
export default {
  name: "intangibleItem-list",
  data () {
    return {
      //抽屉参数
      value3: false,
      exportLoading: false,
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      formData: {
        name: "",
        url: "",
        owner: "",
        type: "",
        approver: "",
        date: "",
        desc: ""
      },
      //
      datePicTwo: "",
      editor: {
        ifno: ""
      },
      bigStatus: "正常",
      PosStatus: "否",
      isClear: false,
      loading: true,
      dataloading: true,
      thumblist: [],
      thumblistTwo: [],
      datePic: [],
      cateList: [],
      levelList: [],
      statusList: [
        { id: 1, name: "正常" },
        { id: 0, name: "禁用" }
      ],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: "",
      formItem: {
        key: ""
      },
      bigDisplay: "",
      list: [
        {
          title: "Id",
          key: "id",
          fixed: "left",
          width: 90
        },
        {
          title: "标题",
          key: "title",
          minWidth: 200,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.title),
              h(
                "span",
                {
                  style: {
                    marginLeft: "5px",
                    color: "#a94442"
                  }
                },
                "图"
              )
            ]);
          }
        },
        {
          title: "地区",
          key: "diqu",
          minWidth: 200,
          render: (h, params) => {
            var s = "";
            if (params.row.area1 != null) s = params.row.area1.areaname;
            if (params.row.area2 != null)
              s = s + "->" + params.row.area2.areaname;
            if (params.row.area3 != null)
              s = s + "->" + params.row.area3.areaname;
            return h("div", [h("span", {}, s)]);
          }
        },
        {
          title: "分类",
          key: "cate_name",
          minWidth: 150,
          render: (h, params) => {
            return h("div", [h("span", {}, params.row.cate.name)]);
          }
        },
        {
          title: "等级",
          key: "levename",
          minWidth: 150
        },
        {
          title: "类型",
          key: "type_id",
          width: 100,
          render: (h, params) => {
            var par = params.row.type_id;
            var s = "";
            for (var i = 0; i < this.typeList.length; i++) {
              if (par == this.typeList[i].type_id) {
                s = this.typeList[i].name;
              }
            }
            return h("div", [h("span", {}, s)]);
          }
        },
        {
          title: "状态",
          key: "status",
          width: 80,
          render: (h, params) => {
            return h("div", [
              h("span", {}, params.row.status == 1 ? "正常" : "禁用")
            ]);
          }
        },
        {
          title: "修改时间",
          key: "updated_at",
          width: 150
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "warning",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.showLocations(params.row.id);
                    }
                  }
                },
                "定位点"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.detail(params.index, params.row.id);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  style: {
                    marginRight: "8px"
                  },
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.index, params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      intangibleItem: {
        name: "",
        status: true,
        is_pos: "0"
      },
      showModalStatus: false,
      intangibleItemValidate: {
        name: [{ required: true, message: "名称必须填写", trigger: "blur" }]
      },
      params: {
        datetime: [],
        datetimeTwo: ""
      },
      typeList: [],
      id: 0,
      name: "",
      shengList: [],
      shiList: [],
      quList: [],
      levelList: []
    };
  },
  created: function () {
    // 取数据
    this.id = this.$route.params.id;

    this.init();
  },
  components: {
    UploadThumb,
    // EditorBar,
    uploadthumbTwo,
    UEditor
  },
  watch: {
    "$route.params.id": function (curVal, oldVal) {
      if (curVal) {
        this.id = curVal;
        this.init();
      }
    }
  },
  methods: {
    init () {
      var getitems = JSON.parse(localStorage.getItem("intangibleItemPs"));
      if (getitems != null) {
        console.log(111);
        (this.formItem = getitems.formItem), (this.pages = getitems.pages);
        this.datePic = getitems.datePic;
        this.params.datetime = getitems.params;
        this.renderTable(1);
      } else {
        console.log(1113);
        this.getTableList();
      }
      this.getCateList();
      this.getTypeList();
      this.getShengList();
      this.getlevelList();
    },
    getTableList: function () {
      this.$api.intangibleItem
        .list({
          page: this.pages.page,
          size: this.pages.size,
          type_id: this.id
        })
        .then(res => {
          // this.$api.intangibleItem.list(ps).then(res=>{
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.$Message.success(res.msg);
            // 同步筛选条件
            this.renderTable();
          }
        });
      return;
    },
    getCateList () {
      this.$api.intangibleCate.list({ page: 1, size: 999 }).then(res => {
        if (res.code == 200) {
          this.cateList = res.result.list;
        }
      });
    },
    getTypeList () {
      this.$api.intangibleLevel.type({ page: 1, size: 999 }).then(res => {
        if (res.code == 200) {
          this.typeList = res.result;
          for (var s in this.typeList) {
            if (this.id == this.typeList[s].type_id)
              this.name = this.typeList[s].name;
          }
        }
      });
    },
    getlevelList () {
      this.$api.intangibleLevel
        .list({ page: 1, size: 999, type_id: this.id })
        .then(res => {
          if (res.code == 200) {
            this.levelList = res.result.list;
          }
        });
    },
    resetFormItem () {
      this.formItem = {};
      (this.pages = {
        page: 1,
        size: 10,
        total: 0
      }),
        (this.datePic = []);
      this.params.datetime = [];
      localStorage.removeItem("intangibleItemPs");
      this.getTableList();
    },
    getShengList () {
      this.$api.intangibleItem.areaList({ id: 0 }).then(res => {
        if (res.code == 200) {
          this.shengList = res.result;
        }
      });
    },
    shengChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then(res => {
          if (res.code == 200) {
            this.shiList = res.result;
          }
        });
      }
    },
    shiChange (value) {
      if (value != undefined) {
        this.$api.intangibleItem.areaList({ id: value }).then(res => {
          if (res.code == 200) {
            this.quList = res.result;
          }
        });
      }
    },
    showLocations (id) {
      this.$router.push("/intangibleLocation/list/" + id);
    },
    changeDate (val) {
      this.params.datetime = val;
    },
    changeDateTwo (val) {
      this.params.datetimeTwo = val;
    },
    // 展开添加
    showModel () {
      this.title = "添加项目";
      this.intangibleItem = {
        name: ""
      };
      this.thumblist = new Array();
      this.thumblistTwo = new Array();
      this.$refs["intangibleItemValidate"].resetFields();
      this.datePic = "";
      this.editor.info = "";
      this.PosStatus = "否";
      // this.$refs['editContent'].editor.txt.html("");
      this.$refs["editContent"].message = "";
      this.showModalStatus = !this.showModalStatus;
      this.datePicTwo = new Date();
      this.params.datetimeTwo = new Date();
    },
    // 详情
    detail (index, id) {
      let that = this;
      this.title = "编辑项目";
      this.intangibleItem = {
        name: ""
      };
      this.thumblist = new Array();
      this.thumblistTwo = new Array();
      this.$refs["intangibleItemValidate"].resetFields();
      this.datePic = "";
      this.editor.info = "";
      this.showModalStatus = !this.showModalStatus;
      this.$api.intangibleItem.detail({ id: id }).then(res => {
        this.intangibleItem = res.result;
        this.PosStatus = this.intangibleItem.is_pos == 1 ? "是" : "否";
        //处理富文本图片
        var good_content = this.intangibleItem.content;
        var content = good_content.replace(
          /(<img [^>]*src=['"])([^'"]+)([^>]*)/g,
          function (match, $1, $2, $3) {
            if (/^http/.test($2)) {
              return $1 + $2 + $3;
            } else {
              return $1 + that.$publicData.ossUrl + $2 + $3;
            }
          }
        );
        this.$refs["editContent"].message = content;
        //处理thumb
        if (
          this.intangibleItem.thumb != null &&
          this.intangibleItem.thumb != ""
        ) {
          this.thumblist.push({
            name: this.intangibleItem.thumb,
            url: this.intangibleItem.thumb,
            status: "finished"
          });
        }
        if (
          this.intangibleItem.attrs != null &&
          this.intangibleItem.attrs.length > 0
        ) {
          for (var s in this.intangibleItem.attrShow) {
            this.thumblistTwo.push({
              name: this.intangibleItem.attrShow[s],
              url: this.intangibleItem.attrShow[s],
              status: "finished"
            });
          }
        }
        this.datePicTwo = this.intangibleItem.publish_at;
        this.params.datetimeTwo = this.intangibleItem.publish_at;
        console.log(this.params.datetimeTwo);
        //省市区三个下拉框
        this.shiList = this.intangibleItem.shiList;
        this.quList = this.intangibleItem.quList;
        this.bigStatus = this.intangibleItem.status == 1 ? "正常" : "禁用";
      });
    },
    // 添加
    createintangibleItem (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          //封面图
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.intangibleItem.thumb = this.$refs[
              "uploadthumb"
            ].uploadList[0].url;
          }
          //状态
          this.intangibleItem.type_id = this.id;
          this.intangibleItem.status == 0;
          this.intangibleItem.status = this.bigStatus == "正常" ? 1 : 0;
          this.intangibleItem.is_pos = this.PosStatus == "是" ? 1 : 0;
          //相册
          if (this.$refs["uploadthumbTwo"].uploadList.length > 0) {
            var finalAttrs = "";
            var tList = this.$refs["uploadthumbTwo"].uploadList;
            for (var s in tList) {
              finalAttrs = finalAttrs + tList[s].url + ",";
            }
            if (finalAttrs != "") {
              this.intangibleItem.attrs = finalAttrs.substring(
                0,
                finalAttrs.length - 1
              );
            }
          }
          //编辑框
          // this.intangibleItem.content = this.editor.info;
          this.intangibleItem.content = this.$refs["editContent"].message;
          //时间
          this.intangibleItem.publish_at = this.params.datetimeTwo;
          if (this.intangibleItem.publish_at instanceof Date) {
            this.intangibleItem.publish_at = this.formatDate(
              this.intangibleItem.publish_at,
              "yyyy-MM-dd hh:mm:ss"
            );
            console.log(this.intangibleItem.publish_at);
          }
          console.log(this.params.datetimeTwo);
          if (this.intangibleItem.id == null || this.intangibleItem.id == 0) {
            this.$api.intangibleItem.create(this.intangibleItem).then(res => {
              if (res.code == 200) {
                this.showModalStatus = false;
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
            });
          } else {
            this.$api.intangibleItem.edit(this.intangibleItem).then(res => {
              if (res.code == 200) {
                this.showModalStatus = false;
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
            });
          }
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.showModalStatus = true;
        }
      });
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.intangibleItem.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.tablelist.splice(index, 1);
            }
          });
        }
      });
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.intangibleItem
        .status({ id: index, status: value })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
          }
        });
    },
    change () { },
    // 导出
    exportData () {
      this.$api.intangibleItem.export({ type_id: this.id }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          window.location.href = res.result;
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable();
    },
    // 筛选
    renderTable: function (name) {
      if (name == 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;
      var bgn_date =
        this.params.datetime[0] != undefined ? this.params.datetime[0] : "";
      var end_date =
        this.params.datetime[1] != undefined ? this.params.datetime[1] : "";
      var ps = {
        key: this.formItem.key,
        page: this.pages.page,
        size: this.pages.size,
        status: this.formItem.status,
        type_id: this.id,
        cate_id: this.formItem.cate_id,
        starttime: bgn_date,
        endtime: end_date,
        level_id: this.formItem.level_id,
        area1: this.formItem.area1,
        area2: this.formItem.area2,
        area3: this.formItem.area3
      };
      let saveItems = {
        formItem: this.formItem,
        pages: this.pages,
        datePic: this.datePic,
        params: this.params.datetime
      };
      localStorage.setItem("intangibleItemPs", JSON.stringify(saveItems));
      this.$api.intangibleItem.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    formatDate (date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      let o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds()
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + "";
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : this.padLeftZero(str)
          );
        }
      }
      return fmt;
    },
    padLeftZero (str) {
      return ("00" + str).substr(str.length);
    }
  }
};
</script>

<style>
.demo-drawer-footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  background: #fff;
  z-index: 20000;
}
</style>
